let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4T4bq"), load("5AfWB")]).then(() => parcelRequire('jubPE'));